import { Badge } from '@/components/ui/badge'
import type { DeviceStatus as DeviceStatusType } from '@/types/device.types'

interface DeviceStatusProps {
  status: DeviceStatusType
}

export const DeviceStatus = ({ status }: DeviceStatusProps) => {
  const statusConfig = {
    ACTIVATED: { label: 'Active', variant: 'success' as const },
    INACTIVE: { label: 'Inactive', variant: 'secondary' as const },
    DECOMMISSIONED: { label: 'Decommissioned', variant: 'destructive' as const }
  }

  const config = statusConfig[status] || statusConfig.INACTIVE

  return <Badge variant={config.variant}>{config.label}</Badge>
}
